import type { FC } from 'react';
import type { LatestRealizedVolsProps } from './types';
import LatestRealizedVolsWidget from './latest-realized-vols-widget';
import { LatestRealizedVolsProvider } from '../../../../providers/latest-realized-vols-provider';

const LatestRealizedVolsWrapperProvider: FC<LatestRealizedVolsProps> = (props) => (
  <LatestRealizedVolsProvider providerKey={props.providerKey}>
    <LatestRealizedVolsWidget {...props} />
  </LatestRealizedVolsProvider>
);

export default LatestRealizedVolsWrapperProvider;
